import React from "react";
import PropTypes from "prop-types";
import { Modal, BlockStack, Text } from "@shopify/polaris";

const DisplayTermsModal = (props) => {
  const {
    showDisplayTermsModal,
    toggleShowDisplayTermsModal,
    financingOption,
  } = props;

  return (
    <Modal
      open={showDisplayTermsModal}
      title={"Term details"}
      onClose={toggleShowDisplayTermsModal}
      secondaryActions={[
        {
          content: "Close",
          onAction: toggleShowDisplayTermsModal,
        },
      ]}
    >
      <Modal.Section>
        {financingOption.attributes.financing_type === "Net terms" && (
          <BlockStack gap="200">
            <Text variant="headingMd" as="h4">
              Net terms
            </Text>
            <Text>
              Payment will be due on the commencement date, according to the
              selected schedule.
            </Text>
          </BlockStack>
        )}

        {!(financingOption.attributes.financing_type === "Net terms") &&
          financingOption.attributes.approval_status === "pending" && (
            <BlockStack gap="200">
              <Text variant="headingMd" as="h4">
                Estimate
              </Text>
              <Text>
                Based on an average scoring of companies in your industry, for
                like product and transaction size, this is an estimated payment
                you can use for budgetary purposes. You can assume this to be
                your payment for this term and structure give or take
                $100/month.
              </Text>
            </BlockStack>
          )}

        {!(financingOption.attributes.financing_type === "Net terms") &&
          financingOption.attributes.approval_status === "pre_approved" && (
            <BlockStack gap="200">
              <Text variant="headingMd" as="h4">
                Pre-approved!
              </Text>
              <Text>
                Great news! Your financing option has been pre-approved based on your 
                initial information. This means you&apos;re very likely to receive full 
                approval with minimal additional requirements, if any.
              </Text>
              <Text>
                Once you select this option and complete any remaining verification 
                steps, final approval and finance documents will be processed quickly.
              </Text>
            </BlockStack>
          )}

        {!(financingOption.attributes.financing_type === "Net terms") &&
          financingOption.attributes.approval_status === "approved" && (
            <BlockStack gap="200">
              <Text variant="headingMd" as="h4">
                You&apos;re approved!
              </Text>
              <Text>No additional information is needed for review.</Text>
              <Text>
                Once you select an option and an authorized signatory is
                confirmed, finance documents will be presented for your review
                and execution.
              </Text>
              <Text>
                There is nothing binding until the finance documents are fully
                executed. If you have any questions, please don&apos;t hesitate
                to be in touch.
              </Text>
            </BlockStack>
          )}
      </Modal.Section>
    </Modal>
  );
};

DisplayTermsModal.propTypes = {
  showDisplayTermsModal: PropTypes.bool,
  toggleShowDisplayTermsModal: PropTypes.func,
  financingOption: PropTypes.object,
  opportunityId: PropTypes.string,
  opportunity: PropTypes.object,
};

export default DisplayTermsModal;
